import { useTranslation } from 'react-i18next';

import FormField from '../../../components/Form/FormField/FormField.component';
import JalaliDatePicker from '../../../components/Form/JalaliDatePicker/JalaliDatePicker.component';

/** Attendance drafts stay in the parent when the course type temporarily changes. */
const InPersonCourseFields = ({ details, onChange }) => {
	const { t } = useTranslation();
	const textField = (field, label, ltr = false) => (
		<FormField key={field} fieldKey={`course_${field}`} title={t(label)} value={details[field]} required ltr={ltr} onChange={event => onChange(field, event.target.value)} />
	);
	const dateField = (field, label, minDate = null) => (
		<JalaliDatePicker key={field} fieldKey={`course_${field}`} title={t(label)} value={details[field] || null} required isSearch={false} yearsForward={10} minDate={minDate} onChange={value => onChange(field, value || '')} />
	);
	return <>
		<div className="col-12"><h6 className="mt-2 mb-3">{t('course_in_person_details')}</h6></div>
		{textField('instructor_name', 'course_instructor_name')}
		{textField('venue', 'course_venue')}
		{dateField('start_date', 'course_start_date')}
		{dateField('end_date', 'course_end_date', details.start_date || null)}
		{textField('schedule', 'course_schedule')}
		{dateField('registration_deadline', 'course_registration_deadline')}
		{textField('sessions_count', 'course_sessions_count', true)}
		{textField('total_hours', 'course_total_hours', true)}
	</>;
};

export default InPersonCourseFields;
